import api from "./axiosInterceptor"

export default async function PostPDF(data, url, type) {

    try {
        const response = await api.post(`api/${url}`, data,
            {
                "content-type": "multipart/form-data",
            })
        if (response.status === 200) {
            return { data: response.data, error: false, load: false }
        } else { return { data: null, error: true, load: false } }

    } catch (err) {
        return { data: null, error: err, load: false }
    }
}